import React, {Component, Fragment} from 'react';
import Alert from '../../../itrust_common/components/Alert';
import { connect } from 'react-redux';
import { scheduleJobLogCreate } from '../../../redux/actions/scheduleJobLogAction';
import { ImportButton } from '../../../itrust_common/components/others';

class SchededuleJobButton extends Component {

  handleExportScheduleJob(){
    if (this.props.totalRecords > 5000){
      Alert.confirm(<div>Your report will start generating during non working hours. Retrieve the report under Logs {'>'} Schedule Job Logs. Once the report has been successfully generated you will receive an email.</div>,
      (res)=> {
        if(res){
         this.props.dispatch(scheduleJobLogCreate(this.props.params))
        }
      }
    )}
    else{
      Alert.confirm(<div>Your report will start generating now. Retrieve the report under Logs {'>'} Schedule Job Logs. Once the report has been successfully generated you will receive an email.</div>,
        (res) => {
          if (res) {
            // this.props.dispatch(paymentReportExport(this.props.params))
            this.props.dispatch(scheduleJobLogCreate(this.props.params))
          }
        }
    )}
  }

  handleImportScheduleJob(data){
    this.props.dispatch(scheduleJobLogCreate(data))
  }

  render() {
    const { params, className, label, isImport } = this.props
    return(
      <>
        {
          isImport ?
          <ImportButton {...this.props} isScheduleJobImport={true} onImportHook={(data) => this.handleImportScheduleJob(data)} />
          :
          <button type="button" onClick={()=> this.handleExportScheduleJob()} className={`btn ${className}`} >{label}</button>
        }
      </>
    )
  }
}
export default connect()(SchededuleJobButton);
